// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button[data-v-0105a630]{align-items:center;background:var(--button-background-color);border:var(--input-border);border-radius:var(--input-border-radius);display:flex;font-weight:500;height:var(--input-height);justify-content:center;padding:var(--input-gutter);text-align:center;text-transform:uppercase}.button--link[data-v-0105a630]{background:none;border:none;-webkit-text-decoration:underline;text-decoration:underline;text-transform:lowercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
